import React, {useContext} from "react" ;
import {Globals} from "root/DataFunctions/BaseDataFns";
import queryString from "query-string";
import {useLocation} from "react-router-dom";
import './ChildAppBodyHeader.scss';
import {UserTypes} from "root/DataFunctions/Constants";
import {useGlobalContext} from "root/contexts/GlobalContext";

const ChildAppBodyHeader= (props) =>
{
    const {search} = useLocation()
    const queryParams = queryString.parse(search);

    const { userType } = useGlobalContext() ;

    const hide_child_image = (userType === UserTypes.BIRTH_PARENT || userType === UserTypes.OTHER) ? true : false;

    const getChildImage = () =>
    {
        const url = hide_child_image || props.document_id === null ? '/images/defaultPerson.jpg' : Globals.APIFolder + '/user/' + props.child_uid + '/avatar?thumb&size=37';
        return url
    }

    const displayHeader = () =>
    {
        switch (queryParams.type)
        {
            case 'posts':
                return <h4 className="title">Posts</h4>
                break;
        }
    }

    const childheaderStyle = {
        display: 'grid',
        gridTemplateColumns: '7rem auto',
        alignItems: 'center'
    } ;

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div style={ childheaderStyle} className="child-menu-item">
                <img alt="image" src={getChildImage()} width='50px' align="left"/>
                <span>{props.child_name}</span>
            </div>

            <div className="child-menu-item">
                {displayHeader()}
            </div>

            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default ChildAppBodyHeader;
